<div class="login-bg-color">
  <mapfre-header></mapfre-header>
  <ng-container *ngIf="isAcmic || !isSignupPage; else maState">
    <!-- <div class="login-bg-mobile" [ngStyle]="{ 'background-image': 'url(' + seasonBackgroundImg + ')' }"></div> -->
    <div class="login-bg" [ngStyle]="{ 'background-image': 'url(' + seasonBackgroundImg + ')' }">
      <div class="container mapfre-content" [ngClass]="{ 'not-logged-page padding-horizontal ph8': !isAcmic ||!isSignupPage}">
        <mapfre-card additionalClasses="signup signupcard" additionalCardContentClasses="signupcard">
          <mapfre-alert [notTop]="false"></mapfre-alert>
          <router-outlet></router-outlet>      
        </mapfre-card>
      </div>
    </div>
  </ng-container>
  <ng-template #maState>
    <div class="login-bg-mobile" [ngStyle]="{ 'background-image': 'url(' + seasonBackgroundImg + ')' }"></div>
    <div class="login-bg login-bg-ma" [ngStyle]="{ 'background-image': 'url(' + seasonBackgroundImg + ')' }">
      <div class="container mapfre-content not-logged-page padding-horizontal ph8">
        
        <mapfre-card additionalClasses="signup signupcard" additionalCardContentClasses="signupcard">
          <mapfre-alert [notTop]="false"></mapfre-alert>
          <router-outlet></router-outlet>
        </mapfre-card>
      </div>
    </div>
  </ng-template>
</div>